// Fonte única de verdade para cores/rótulos de status.
// Qualquer card que precise pintar um estado usa este mapa.

export const STATUS = {
  done: {
    label: 'Concluído',
    dot: 'bg-up-green',
    text: 'text-up-green',
    icon: 'text-white bg-up-green',
    badge: 'bg-up-green/10 text-up-green',
    ring: 'ring-up-green',
  },
  in_progress: {
    label: 'Em andamento',
    dot: 'bg-up-amber',
    text: 'text-up-amber',
    icon: 'text-up-gray bg-slate-100',
    badge: 'bg-up-amber/10 text-up-amber',
    ring: 'ring-up-amber',
  },
  active: {
    label: 'Em execução',
    dot: 'bg-up-orange',
    text: 'text-up-orange',
    icon: 'text-white bg-up-orange',
    badge: 'bg-up-orange/10 text-up-orange',
    ring: 'ring-up-orange',
  },
  pending: {
    label: 'Pendente',
    dot: 'bg-up-gray',
    text: 'text-up-gray',
    icon: 'text-up-gray bg-slate-100',
    badge: 'bg-slate-100 text-up-gray',
    ring: 'ring-up-gray',
  },
}

export const status = (state) => STATUS[state] ?? STATUS.pending

// Variantes usadas pelos badges de pagamento.
export const PAYMENT_VARIANT = {
  success: 'bg-up-green/10 text-up-green',
  warning: 'bg-blue-50 text-blue-700',
  muted: 'bg-slate-100 text-slate-500',
}

export const paymentVariant = (variant) => PAYMENT_VARIANT[variant] ?? PAYMENT_VARIANT.muted

// Estados das parcelas na tela de Pagamentos (acompanhamento, sem cobrança).
export const PAYMENT_STATUS = {
  paid: {
    label: 'Pago',
    badge: 'bg-up-green/10 text-up-green',
    dot: 'bg-up-green',
    text: 'text-up-green',
  },
  due: {
    label: 'A vencer',
    badge: 'bg-blue-50 text-blue-700',
    dot: 'bg-up-amber',
    text: 'text-up-amber',
  },
  overdue: {
    label: 'Vencido',
    badge: 'bg-red-50 text-red-700',
    dot: 'bg-red-500',
    text: 'text-red-600',
  },
  pending: {
    label: 'Programada',
    badge: 'bg-slate-100 text-slate-500',
    dot: 'bg-up-gray',
    text: 'text-up-gray',
  },
  waiting: {
    label: 'Aguardando conclusão',
    badge: 'bg-slate-100 text-slate-500',
    dot: 'bg-up-gray',
    text: 'text-up-gray',
  },
}

export const paymentStatus = (state) => PAYMENT_STATUS[state] ?? PAYMENT_STATUS.pending
